import { format } from 'date-fns'

import { i18nDateToString } from 'modules/core/lib/dates'
import type { View } from 'modules/shift_management/lib/types'

const formatHeader = (date: Date, view: View, isTimeFormat24H: boolean) => {
  if (view.isDaily) {
    if (isTimeFormat24H) return format(date, 'HH')
    const hour = date.getHours()
    const suffix = hour < 12 ? 'am' : 'pm'
    const displayHour = hour % 12 || 12
    return `${displayHour}${suffix}`
  }

  const shortDate = i18nDateToString(date, 'ui_short')
  if (view.isWeekly || view.isFourWeeks) return shortDate
  return format(date, 'd') + ' ' + shortDate.slice(0, 2)
}

export { formatHeader }
